/* eslint-disable array-callback-return */
import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import BillingTab from "./Tabs/BillingTab";
import InvoiceTab from "./Tabs/InvoiceTab";
import SuccessModal from "../../common/SuccessModal/SuccessModal";
import ErrorModal from "../../common/ErrorModal/ErrorModal";
import AchPaymentModal from "../../common/AchPaymentModal/AchPaymentModal";
import "../../../assets/css/components/Profile/BillingComponent/BillingComponent.css";
import Icon from "react-icons-kit";
import { androidClose } from "react-icons-kit/ionicons/androidClose";
import BIllingForm from "./BIllingForm";
import AlertBox from "../../common/UI/AlertBox/AlertBox";

const BIllingFormModal = (props) => {
  const { visibleModal, closeModal, screen, showPopup, handleActiveTab, setScreen } = props
  return (
      <AlertBox
        alertVisibility={visibleModal === 3 ? true : false}
        closeAlertBoxHandler={closeModal}
        backdrop={true}
        alertClass={
          screen === 1
            ? "iz-modal add-card-modal"
            : "iz-modal add-card-modal custom_billing_modal"
        }
      >
        <div className="modal-wrapper">
          <div className="modal-header">
            <h3 id="payHeader">Pay Invoice</h3>
            <span onClick={closeModal} className="close-icon-wrapper">
              <Icon size={24} icon={androidClose} className="cursor-pointer" />
            </span>
          </div>
          <div className="modal-body">
              <BIllingForm
                screen={screen}
                setScreen={setScreen}
                showPopup={showPopup}
                handleActiveTab={handleActiveTab}
                closeModalHandler={closeModal}
              />
          </div>
        </div>

      </AlertBox>
  )
}

const BillingComponent = inject("sharedStore")(
  observer((props) => {
    const { sharedStore: { paymentArr, bankArr, payableAmount } } = props
    const [selectedTab, setSelectedTab] = useState("invoices")
    const [visibleModal, setVisibleModal] = useState("")
    const [modalMsg, setModalMsg] = useState("")
    const [screen, setScreen] = useState("")


    const handleActiveTab = (name) => {
      setSelectedTab(name)
    }

    const closeModal = () => {
      setVisibleModal("")
    };


    const showPopup = (val, msg) => {
      setVisibleModal(val)
      setModalMsg(msg)
    };

    const navigateScreen = (e, number) => {
      setScreen(number)
    };

    const handlePayNow = () => {
      let tab =
        (bankArr && bankArr.length > 0) || (paymentArr && paymentArr.length > 0)
          ? selectedTab
          : "billing";
      setVisibleModal(3)
      setSelectedTab(tab)
      setScreen(1)
    };


    return (
      <div className="billing-wrapper app-tab-wrapper">
        {/* Success Modal */}
        <SuccessModal
          modalVisibility={visibleModal === 1 ? true : false}
          closeModalHandler={closeModal}
          messageContent={modalMsg}
          modalLabel="Success Modal"
          doneBtnId="doneButtonProfile"
          modalClass="iz-modal"
        />

        {/* Error Modal */}
        <ErrorModal
          modalVisibility={visibleModal === 2 ? true : false}
          closeModalHandler={closeModal}
          messageContent={modalMsg}
          modalLabel="Error Modal"
          modalClass="iz-modal"
        />

        {/* ACH Payment Modal */}
        <AchPaymentModal
          modalVisibility={visibleModal === 4 ? true : false}
          closeModalHandler={closeModal}
          messageContent={modalMsg}
          modalLabel="Success Modal"
          doneBtnId="doneButtonProfile"
          modalClass="iz-modal"
        />
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 billingTabs">
            <ul className="nav nav-tabs">
              <li
                className={selectedTab === "invoices" ? "active" : ""}
                onClick={() => handleActiveTab("invoices")}
              >
                <a>Invoices</a>
              </li>
              <li
                className={selectedTab === "billing" ? "active" : ""}
                onClick={() => handleActiveTab("billing")}
              >
                <a id="paymentTab">Payment Profile</a>
              </li>
            </ul>
          </div>
          <div className={payableAmount > 0.0 ? "balanceDue" : "balanceNone"}>
            Balance Due:{" "}
            <div className="grandTotal">
              $
            {parseFloat(payableAmount, 10).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}
            </div>
          </div>

          {payableAmount > 0.0 ? (
            <div
              className="col-xs-12 col-sm-4 col-md-4 text-right xs-abs-col"
              id="payNowBtn"
            >
              <button
                className="btn btn-common"
                onClick={handlePayNow}
              >
                Pay Invoice
            </button>
              {visibleModal === 3 &&
                ((paymentArr && paymentArr.length > 0) ||
                  (bankArr && bankArr.length > 0)) && (
                  <BIllingFormModal
                    visibleModal={visibleModal}
                    closeModal={closeModal}
                    screen={screen}
                    showPopup={showPopup}
                    handleActiveTab={handleActiveTab}
                    setScreen={navigateScreen}
                  />
                )}
            </div>
          ) : null}
        </div>
        <div className="tab-content billingTabContent">
          <div
            className={`tab-pane fade invoicePane ${selectedTab === "invoices" ? "in active" : ""
              }`}
          >
            <InvoiceTab />
          </div>
          <div
            className={`tab-pane fade billingPane ${selectedTab === "billing" ? "in active" : ""
              }`}
          >
            <BillingTab />
          </div>
        </div>
      </div>
    );
  }))

export default BillingComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/BillingComponent.jsx